
export const SET_MSG = 'FATURA_MSG';
export const SET_EDITAR = 'FATURA_EDITAR';
export const SET_LISTA = 'FATURA_LISTA';
export const SET_PESQUISA = 'FATURA_PESQUISA';
export const SET_BOLETINS = 'FATURA_BOLETINS';
export const SET_TAXAS = 'FATURA_TAXAS';
export const SET_FATURA_ID = 'FATURA_ID';
export const SET_RUBLICAS = 'FATURA_RUBLICAS';
export const SET_TRABALHADORES = 'FATURA_TRABALHADORES';